import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

const addMmrCalculatedValue = createAction(actionType.ADD_MMR_CALCULATED_VALUE);
const clearMmrCalculatedValue = createAction(
  actionType.CLEAR_MMR_CALCULATED_VALUE
);

export { addMmrCalculatedValue, clearMmrCalculatedValue };
